import actionTypes from './upcomingPublication.actionTypes';
import { createPriceBuckets, getAvaiabletypeOfContract } from '../common/sponsorships/filters/filterHelper';
import {getNextMonths} from '../common/sponsorships/filters/dateFilterHelper';
import * as sponsorshipHelper from '../common/sponsorships/list/sponsorshipHelper';


const initialUpcomingPublicationsState = {
    isFetching: false,
    pagination: {
        currentPage: 1,
        pageSize: 50,
        recordTotal: 0
    },
    data: [],
    totals: {},
    isExporting: false
};

//Reducers

export function upcomingPublications(state = initialUpcomingPublicationsState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.REQUEST_UPCOMING_PUBLICATIONS:
            Object.assign(nextState, state, {
               isFetching: true 
            });
            break;
        case actionTypes.RECEIVE_UPCOMING_PUBLICATIONS_SUCCESS: {
            const pagination = action.pagination;
            Object.assign(nextState, state, {
                isFetching: false,
                lastUpdated: action.receivedAt,
                pagination: {
                    pageNumber: pagination.page,
                    pageSize: pagination.per_page,
                    recordTotal: pagination.total
                },
                data: sponsorshipHelper.convertUpcomingPublications(action.publications),
                totals: {
                    price: action.totals.total_price
                }
            });
            break;
        }
        case actionTypes.EXPORT_UPCOMING_PUBLICATIONS:
            Object.assign(nextState, state, {
                isExporting: true 
             });
             break;
        case actionTypes.EXPORT_UPCOMING_PUBLICATIONS_SUCCESS:
            Object.assign(nextState, state, {
                isExporting: false
             });
             break;
        default:
            nextState = state;
    }
    return nextState;
}

const initialPublicationFiltersState = {
    isFetching: false,
    all: {},
    filterQueryString: '', //Query string that includes the selected filters.
    searchText: ''
};

export function upcomingPublicationFilters(state = initialPublicationFiltersState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.REQUEST_UPCOMING_PUBLICATION_FILTERS:
            Object.assign(nextState, state, {
               isFetching: true 
            });
            break;
        case actionTypes.RECEIVE_UPCOMING_PUBLICATION_FILTERS_SUCCESS: {
            Object.assign(nextState, state, {
                isFetching: false,
                lastUpdated: action.receivedAt,
                all: {
                    publicationStatuses: action.publication_statuses,
                    priceBuckets: createPriceBuckets(action.price_buckets),
                    months: getNextMonths(), //Months are calculated client-side.
                    budgets: action.budgets,
                    typeOfContract: getAvaiabletypeOfContract()
                },
                filterQueryString: ''
            });
            break;
        }
        case actionTypes.RECEIVE_UPCOMING_PUBLICATIONS_SUCCESS:
            Object.assign(nextState, state, {
                filterQueryString: action.filterQueryString,
                searchText: action.searchText,
                sortField: action.sortField,
                sortDirection: action.sortDirection
            });
            break;
        default:
            nextState = state;
    }
    return nextState;
}